import { createSlice } from "@reduxjs/toolkit";
import { getAllTransactions, getDateFilterOrderTransactions, getTransactions } from "../../api/transaction";

const initialState = {
  isAdded: false,
  isLoading:false,
  transactions:[],
  transactionReports:[],
  orderTransactions:[],
  page:0,
  value:0
};

export const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    setTransactions: (state, action) => {
      state.transactionReports = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setValue: (state, action) => {
      state.value = action.payload;
    }
  },
  extraReducers: {
    [getTransactions.pending]: (state) => {
      state.isLoading = true;
    },
    [getTransactions.fulfilled]: (state,{payload}) => {
      state.isLoading = false;
      state.transactions = payload
    },
    [getTransactions.rejected]: (state) => {
      state.isLoading = false;

    },
    [getAllTransactions.pending]: (state) => {
      state.isLoading = true;
    },
    [getAllTransactions.fulfilled]: (state,{payload}) => {
      state.isLoading = false;
      state.transactions = payload
    },
    [getAllTransactions.rejected]: (state) => {
      state.isLoading = false;

    },
    [getDateFilterOrderTransactions.pending]: (state) => {
      state.isLoading = true;
    },
    [getDateFilterOrderTransactions.fulfilled]: (state,{payload}) => {
      state.isLoading = false;
      state.orderTransactions = payload
    },
    [getDateFilterOrderTransactions.rejected]: (state) => {
      state.isLoading = false;

    },
  },
});

export const { setTransactions, setPage, setValue } = transactionSlice.actions;
export const transactionSelector = (state) => state.transaction;
export default transactionSlice.reducer;
